import React, { useEffect, useState } from "react";
import "./styles.scss";
import Layout from "./Layout";
import CheckoutForm from "./CheckoutForm";

const Payments = (props: any) => {
	const [userEmail, setUserEmail] = useState("");
	const [userName, setuserName] = useState("");

	useEffect(() => {
		const queryString = window.location.search;
		if (queryString) {
			const urlParams = new URLSearchParams(queryString);
			const email = urlParams.get("email");
			const fullName = urlParams.get("name");
			// payments?email=qa_shop@gutenbergcerts.com&name=John%20Doe
			// clear parameters
			window.history.replaceState(null, "", window.location.pathname);
			if (email && fullName) {
				// setEmailFromParams(true);
				// setRegisterData({
				//   ...registerData,
				//   emailAddress: email,
				//   firstName: firstName,
				//   lastName: lastName,
				// })
				setUserEmail(email);
				setuserName(fullName);
				console.log("parameters: ", email, fullName);
			}
		}
	}, []);

	return (
		<Layout title="Gutenberg certificate checkout">
			<CheckoutForm
				batch_id={props.certificate.batch_id}
				credential_id={props.certificate.credential_id}
				issuer_code={props.certificate.issuer_code}
				template_code={props.certificate.template_code}
				certificate_name={props.certificate.certificate_name}
				price={Number(props.certificate.certificate_price)}
				userName={props.certificate.recipient_name}
				userEmail={props.certificate.recipient_email}
				onSuccessfulCheckout={() => {
					props.onSuccess();
					console.log("success");
				}}
				onErrorCheckout={() => {
					props.onError();
					console.log("payment error");
				}}
			/>
		</Layout>
	);
};

export default Payments;
